import { Component } from '@angular/core';
import { SyncService } from '../../../../services/sync-service';
import { IndexDbHelpMethod } from '../../../../services/index-db-help-method';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-form-offline-sync-indicator-component',
  imports: [],
  templateUrl: './form-offline-sync-indicator-component.html',
  styleUrl: './form-offline-sync-indicator-component.scss'
})
export class FormOfflineSyncIndicatorComponent {
  isSyncing = false;
  hasOfflineForms = false;

  constructor(
    private syncService: SyncService,
    private idbHelper: IndexDbHelpMethod
  ) {
    this.checkOfflineForms();
  }

  async checkOfflineForms() {
    try {
      const offlineForms = await firstValueFrom(this.idbHelper.getAllOfflineForms());
      this.hasOfflineForms = offlineForms && offlineForms.length > 0;
    } catch (error) {
      console.error('Error checking offline forms:', error);
      this.hasOfflineForms = false;
    }
  }

  async syncData() {
    if (this.isSyncing) {
      return; // Prevent multiple simultaneous syncs
    }

    this.isSyncing = true;
    try {
      await this.syncService.syncOfflineForms();
      // Refresh the offline forms status after sync
      await this.checkOfflineForms();
    } catch (error) {
      console.error('Error during sync:', error);
    } finally {
      this.isSyncing = false;
    }
  }
}
